import React, { useState, useEffect } from 'react';
import { checkMenu, getToken } from '../Utils/Common';
import DefaultLayout from '../component/DefaultLayout';
import Footer from '../component/Footer';
import Api from '../config/Api';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Card from 'react-bootstrap/Card';
import { AiOutlineRollback } from "react-icons/ai";
import { BsCloudDownloadFill } from "react-icons/bs";
import { useHistory, useParams, Link } from 'react-router-dom';
import PSPDFKit from "pspdfkit";
import { defaultConf } from "../config/DefaultConf";
import Alert from 'react-bootstrap/Alert';
import InputMask from 'react-input-mask';
import { toast } from 'react-toastify';
import moment from 'moment'
import Navbar from 'react-bootstrap/Navbar';
import Table from 'react-bootstrap/Table';
import ReactPaginate from "react-paginate";
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import 'bootstrap/dist/css/bootstrap.min.css';

function Editfile() {
    const history = useHistory();
    const [roles, setRoles] = useState([]);
    const [error, setError] = useState(null);
    const {id} = useParams();
    const [dataDetails, setDataDetails] = useState({});
    const [validated, setValidated] = useState(false);

    const [dataList, setDataList] = useState([])
    const [dataPasien, setDataPasien] = useState([])
    const [dataDokter, setDataDokter] = useState([])
    const [dataICD10, setDataICD10] = useState([])
    const [defaultSelectedPasien, setDefaultSelectedPasien] = useState({})
    const [defaultSelectedDokter, setDefaultSelectedDokter] = useState({})
    const [defaultSelectedICD10, setDefaultSelectedICD10] = useState({})
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(5);
    const [pages, setPages] = useState(0);
    const [rows, setRows] = useState(0);
    const [keyword, setKeyword] = useState("");
    const [query, setQuery] = useState("");

    const [formData, setFormData] = useState({
        first_name: '',
        middle_name: '',
        last_name: '',
        user_name: '',
        nik: '',
        email: '',
        gender: '',
        mobile_phone: '',
        phone_number: '',
        role_id: '',
        avatar: '',
        date_of_birth: '',
        umur: '',
        allow_remote: ''
    });

    const dataFile = [];
    const uploadPathURLPDF = defaultConf.url + "download/";

    useEffect(() => {
        getDetails()
        getDataList()
    }, [page, keyword]);


    const getAge = (date) => {
        var today = new Date();
		var birthday = new Date(date);
		var year = 0;
		if (today.getMonth() < birthday.getMonth()) {
			year = 1;
		} else if ((today.getMonth() == birthday.getMonth()) && today.getDate() < birthday.getDate()) {
			year = 1;
		}
		var age = today.getFullYear() - birthday.getFullYear() - year;
 
		if(age < 0){
			age = 0;
		}
        return age
    }

    const getDataList = async () => {
        await Api().get(`clients?role_id=${defaultConf.pasien_role_id}&filter=${keyword}&fields=first_name,middle_name,last_name,email,user_name,mobile_phone,gender&page=${page}&limit=${limit}`)
        .then((response) => response)
        .then((data) => {
          const listData = data.data;
          setDataList(listData.docs);
          setPage(listData.page);
          setPages(listData.totalPages);
          setRows(listData.totalDocs);
        })
        .catch((err) => {
        })
    }

    const changePage = ({ selected }) => {
        setPage(selected+1);
    }

    const searchData = (e) => {
        e.preventDefault();
        setPage(0);
        setKeyword(query);
    }

    const showToastMessage = (msg) => {
        toast.success(msg);
    };

    function handleChange(e) {
        const key = e.target.name;
        const value = e.target.value;
        setFormData({...formData, [key]: value})
    }
    function handleChangeSelect(e) {
        const name = e.name;
        const label = e.label;
        const value = e.value;
        setFormData({...formData, [name]: value})
    }

    const getDetails = async (e) => {
        Api().get(`files/${id}`)
        .then((response) => response)
        .then( async (data) => {
            if(data.status === 200 || data.status === 201 )
            {
                dataFile.descriptions = data.data.descriptions
                dataFile.filename = data.data.filename
                dataFile.mimetype = data.data.mimetype
                dataFile.size = data.data.size
                dataFile.status = data.data.status
                dataFile.thumbnail = data.data.thumbnail
                dataFile.upload_file = data.data.upload_file
                dataFile._id = data.data._id
                dataFile.document = uploadPathURLPDF+data.data.filename
                getPasien(data.data)
                getDokter(data.data)
                getICD10(data.data)
                setDataDetails(dataFile);
                
                let instance;
                const downloadButton = {
                    type: "custom",
                    id: "download-pdf",
                    // icon: ``,
                    title: "Save File",
                    onPress: () => {
                        instance.exportPDF().then(async (buffer) => {
                            const blob = new Blob([buffer], { type: "application/pdf" });
                            const fileName = data.data.filename;
                            if (window.navigator.msSaveOrOpenBlob) {
                                // window.navigator.msSaveOrOpenBlob(blob, fileName);
                            } else {
                                const arrayBuffer = await instance.exportPDF();
                                const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
                                const formData = new FormData();
                                formData.append("files", blob, data.data.filename);
                                await Api().patch(`updatefilemoderator/${id}`, formData, {
                                    headers: {
                                        "Content-Type": "multipart/form-data",
                                    }
                                }).then((response) => response)
                                .then((responseUpdate) => {
                                    // history.push(`/listmedical`);
                                    showToastMessage('File sudah tersimpan');
                                })
                                .catch((err) => {
                                });
                            }
                        });
                    }
                };

                const token = getToken();
                const headers = new Headers();
                headers.set("Authorization", `Bearer ${token}`);

                const pdfResponse = await fetch(uploadPathURLPDF+data.data.filename, { headers });
                const documentBuffer = await pdfResponse.arrayBuffer();

                const toolbarItems = PSPDFKit.defaultToolbarItems;
                
                const newToolbarItems = toolbarItems.filter(
                    items => items.type !== "export-pdf" && 
                    items.type !== "sidebar-thumbnails" && 
                    items.type !== "sidebar-annotations" && 
                    items.type !== "sidebar-document-outline" && 
                    items.type !== "sidebar-bookmarks" && 
                    items.type !== 'print' && 
                    items.type !== 'link'
                )
                newToolbarItems.push({ type: "undo" })
                newToolbarItems.push({ type: "redo" })
                newToolbarItems.push(downloadButton);
                const baseUrl = `${window.location.protocol}//${window.location.host}/assets/js/`;

                PSPDFKit.load({
                    baseUrl,
                    container: "#pspdfkit",
                    document: documentBuffer,
                    enableHistory: true,
                    toolbarItems: newToolbarItems,
                    theme: PSPDFKit.Theme.DARK,
                    enableClipboardActions: true,
                })
                .then(_instance => {
                    instance = _instance;
                })
                .catch(error => {
                });
            }
            
        })
        .catch((err) => {
       });
    }
    
    const formatMobilePhone = (mobile_no) => {
        let mobile = mobile_no;
        let firstNo = String(mobile.substring(0, 1));
        if( firstNo === '0' )
        {
            mobile = '+62' + mobile.slice(1);
        }
        let secondNo = String(mobile.substring(0, 2));
        if( secondNo === '62' )
        {
            mobile = '+62' + mobile.slice(2);
        }
        mobile = mobile.replace(' ', '');
        mobile = mobile.replace('+62', '');
        return mobile
    }

    const formatPhone = (phone_no) => {
        let phone = phone_no;
        phone = phone.replace(' ', '');
        phone = phone.replace('+62', '0');
        return phone
    }

    const formatPhonetoSave = (phone_no) => {
        let phone = phone_no;
        let firstNo = String(phone.substring(0, 1));
        if( firstNo === '0' )
        {
            phone = '+62' + phone.slice(1);
        }
        let secondNo = String(phone.substring(0, 2));
        if( secondNo === '62' )
        {
            phone = '+62' + phone_no.slice(2);
        }

        let thirdNo = String(phone.substring(0, 3));
        if( secondNo === '062' )
        {
            phone = '+62' + phone_no.slice(3);
        }
        return phone
    }

    const handleSaveFile = async (req, res) => {
        req.preventDefault();
        const form = req.currentTarget;
        if (form.checkValidity() === false) {
            req.preventDefault();
            req.stopPropagation();
        }
        setValidated(true);
        var data = new FormData(form);
        let formObject = Object.fromEntries(data.entries());

        await Api().patch(`savefile/${id}`, formObject)
        .then((response) => response)
        .then((data) => {
            console.log(data)
            if( data.status === 201 || data.status === 200 ){
                window.location.reload(false);
            }
        })
        .catch((err) => {
        });
    }

    const handleSubmit = async (req, res) => {
        req.preventDefault();
        const form = req.currentTarget;
        if (form.checkValidity() === false) {
            req.preventDefault();
            req.stopPropagation();
        }
        setValidated(true);
        var data = new FormData(form);
        let formObject = Object.fromEntries(data.entries());
        formObject.role_id = defaultConf.pasien_role_id
        formObject.email = formObject.first_name+formObject.middle_name+formObject.last_name+"@pasien.meditechindo.com"
        if( formObject.umur !== '' )
        {
            formObject.date_of_birth = moment().subtract(formObject.umur, 'years').format('DD-MM-YYYY')
        }

        formObject.mobile_phone = formatMobilePhone(formObject.mobile_phone);
        formObject.mobile_phone = '+62' + formObject.mobile_phone;
        formObject.phone_number = formatPhonetoSave(formObject.phone_number);
        formObject.allow_remote = false;
        
        await Api().post('clients', formObject)
        .then((response) => response)
        .then((data) => {
            console.log(data)
            if( data.status === 201 || data.status === 200 ){
                // history.push(`/editmoderator/${id}`);
                window.location.reload(false);
            }
            else
            {
                let msg = data.data.errors.msg;
                if( data.data.errors.msg === 'CLIENT_ALREADY_EXISTS' )
                {
                    msg = 'Pasien sudah terdaftar'
                }
                setError(msg)
            }
        })
        .catch((err) => {
        });
    };

    const handleChangePasien = async (e, callback) => {
        const key = e.target.label;
        const value = e.target.value;
        console.log(value)
        await Api().get(`clients?role_id=${defaultConf.pasien_role_id}&limit=1000000&fields=first_name,middle_name,last_name&filter=${e}&sort=first_name&order=1`)
        .then((response) => response)
        .then((data) => {
            console.log('data pasien', data)
            const listData = [];
            for( let i=0; i < data.data.totalDocs; i++ )
            {
                listData.push(
                    { 
                        name: 'pasien_id', 
                        value: data.data.docs[i]._id, 
                        label: data.data.docs[i].first_name + ' ' +data.data.docs[i].middle_name + ' ' +  data.data.docs[i].last_name
                    }
                )
            }
            callback(listData);
        })
        .catch((err) => {
        })
    }
    
    const getPasien = async (data) => {
        await Api().get(`clients?role_id=${defaultConf.pasien_role_id}&limit=1000000`)
        .then((response) => response)
        .then((respPasien) => {
            if( respPasien.status === 200 )
            {
                console.log(respPasien)
                const listPasien = [];
                for( let i=0; i < respPasien.data.totalDocs; i++ )
                {
                    if( data?.pasien_id === '' || data?.pasien_id === null || typeof(data?.pasien_id) === 'undefined' )
                    {
                        defaultSelectedPasien.label = 'Select Pasien'
                        defaultSelectedPasien.value = '';
                        defaultSelectedPasien.name = 'pasien_id';
                    }
                    else if( data.pasien_id !== '' && respPasien.data.docs[i]._id === data.pasien_id?._id )
                    {
                        defaultSelectedPasien.label = respPasien.data.docs[i].first_name + ' ' +respPasien.data.docs[i].middle_name + ' ' +  respPasien.data.docs[i].last_name
                        defaultSelectedPasien.value = respPasien.data.docs[i]._id;
                        defaultSelectedPasien.name = 'pasien_id';
                    }
                    listPasien.push({ value: respPasien.data.docs[i]._id, label: respPasien.data.docs[i].first_name + ' ' +respPasien.data.docs[i].middle_name + ' ' +  respPasien.data.docs[i].last_name, name: 'pasien_id' })
                }

                setDataPasien(listPasien);
                setDefaultSelectedPasien(defaultSelectedPasien);
            }
        })
        .catch((err) => {
        })
    }

    const getDokter = async (data) => {
        await Api().get(`clients?role_id=${defaultConf.dokter_admin_role_id}&limit=1000000`)
        .then((response) => response)
        .then((respDokter) => {
            if( respDokter.status === 200 )
            {
                console.log(respDokter)
                const listDokter = [];
                for( let i=0; i < respDokter.data.totalDocs; i++ )
                {
                    if( data?.doctor_id === '' || data?.doctor_id === null || typeof(data?.doctor_id) === 'undefined' )
                    {
                        defaultSelectedDokter.label = 'Select Dokter'
                        defaultSelectedDokter.value = '';
                        defaultSelectedDokter.name = 'doctor_id';
                    }
                    else if( typeof(data?.doctor_id) !== 'undefined' && respDokter.data.docs[i]._id === data.doctor_id?._id )
                    {
                        defaultSelectedDokter.label = ( typeof(respDokter.data.docs[i].first_degree) !== 'undefined' ? respDokter.data.docs[i].first_degree + '. ' : '' ) + respDokter.data.docs[i].first_name + ' ' + respDokter.data.docs[i].middle_name + ' ' +  respDokter.data.docs[i].last_name  +  ( typeof(respDokter.data.docs[i].degree ) !== 'undefined' ? ', ' + respDokter.data.docs[i].degree : '' )
                        defaultSelectedDokter.value = respDokter.data.docs[i]._id;
                        defaultSelectedDokter.name = 'doctor_id';
                    }
                    listDokter.push({ value: respDokter.data.docs[i]._id, label: ( typeof(respDokter.data.docs[i].first_degree) !== 'undefined' ? respDokter.data.docs[i].first_degree + '. ' : '' ) + respDokter.data.docs[i].first_name + ' ' + respDokter.data.docs[i].middle_name + ' ' +  respDokter.data.docs[i].last_name  +  ( typeof(respDokter.data.docs[i].degree) !== 'undefined' ? ', ' + respDokter.data.docs[i].degree : '' ), name: 'doctor_id' })
                }

                setDataDokter(listDokter);
                setDefaultSelectedDokter(defaultSelectedDokter);
            }
        })
        .catch((err) => {
        })
    }

    const getICD10 = async (data) => {
        await Api().get(`icd10?limit=1000000`)
        .then((response) => response)
        .then((respICD10) => {
            if( respICD10.status === 200 )
            {
                console.log(respICD10)
                const listICD10 = [];
                for( let i=0; i < respICD10.data.totalDocs; i++ )
                {
                    if( data?.icd10_id === '' || data?.icd10_id === null || typeof(data?.icd10_id) === 'undefined' )
                    {
                        defaultSelectedICD10.label = 'Select ICD10'
                        defaultSelectedICD10.value = '';
                        defaultSelectedICD10.name = 'icd10_id';
                    }
                    else if( data.icd10_id !== '' && respICD10.data.docs[i]._id === data.icd10_id?._id )
                    {
                        defaultSelectedICD10.label = respICD10.data.docs[i].code + ' : ' + respICD10.data.docs[i].name
                        defaultSelectedICD10.value = respICD10.data.docs[i]._id;
                        defaultSelectedICD10.name = 'icd10_id';
                    }
                    listICD10.push({ value: respICD10.data.docs[i]._id, label: respICD10.data.docs[i].code + ' : ' + respICD10.data.docs[i].name, name: 'icd10_id' })
                }

                setDataICD10(listICD10);
                setDefaultSelectedICD10(defaultSelectedICD10);
            }
        })
        .catch((err) => {
        })
    }

    return (
        <>
            <DefaultLayout />
            <div className="content-wrapper">
                <div className="content-header">
                    <Container fluid>
                        <Row className="mb-2">
                            <Col sm={6}>
                                <h1 className="m-0">Add Data Pasien</h1>
                                <h4 className="m-0">File Name : {dataDetails.filename}</h4>
                            </Col>
                            <Col sm={6}>
                                <Breadcrumb className="breadcrumb float-sm-right">
                                    <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                                    <Breadcrumb.Item href="/listmedical">Files</Breadcrumb.Item>
                                    <Breadcrumb.Item active>Add Data Pasien</Breadcrumb.Item>
                                </Breadcrumb>
                            </Col>
                        </Row>
                    </Container>
                </div>
                    
                <div className="content">
                    <Container fluid>
                        <Row>
                            <Col lg={12}>
                                <Card className="content-list">
                                    <Card.Header>
                                    { checkMenu('listmedical') &&
                                        <Link to="/listmedical"><Button variant="outline-primary"><AiOutlineRollback /> Back</Button></Link>
                                    }
                                    </Card.Header>
                                    <Card.Body>
                                        <Row>
                                            <Col md={6}>
                                                <div className="PDF-viewer">
                                                    <div id="pspdfkit" style={{width: "100%", height: "100vh"}}></div>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <Row>
                                                    <Col md="12">
                                                        <Card className="content-list">
                                                            <Card.Header>
                                                                <h5>File Details</h5>
                                                            </Card.Header>
                                                            <Card.Body>
                                                                <Form noValidate validated={validated} onSubmit={handleSaveFile}>
                                                                    <Row className="mb-3">
                                                                        <Form.Group as={Col} md="6" controlId="validationCustom01">
                                                                            <Form.Label>Pasien</Form.Label>
                                                                            <Select 
                                                                                required
                                                                                options={dataPasien} 
                                                                                name="pasien_id"
                                                                                defaultValue={defaultSelectedPasien}
                                                                                onChange={handleChangeSelect}
                                                                                // onKeyDown={handleChangePasien}
                                                                            />
                                                                        </Form.Group>
                                                                        <Form.Group as={Col} md="6" controlId="validationCustom02">
                                                                            <Form.Label>Dokter</Form.Label>
                                                                            <Select 
                                                                                required
                                                                                options={dataDokter} 
                                                                                name="doctor_id"
                                                                                defaultValue={defaultSelectedDokter}
                                                                                onChange={handleChangeSelect}
                                                                                // onKeyDown={handleChangePasien}
                                                                            />
                                                                        </Form.Group>
                                                                    </Row>
                                                                    <Row className="mb-3">
                                                                        <Form.Group as={Col} md="6" controlId="validationCustom03">
                                                                            <Form.Label>ICD10</Form.Label>
                                                                            <Select 
                                                                                required
                                                                                options={dataICD10} 
                                                                                name="icd10_id"
                                                                                defaultValue={defaultSelectedICD10}
                                                                                onChange={handleChangeSelect}
                                                                                // onKeyDown={handleChangePasien}
                                                                            />
                                                                        </Form.Group>
                                                                    </Row>
                                                                    <Row className="mb-3">
                                                                        <Form.Group as={Col} md="12" controlId="validationCustom14">
                                                                            <Form.Label>Short Descriptions</Form.Label>
                                                                            <Form.Control
                                                                                as="textarea"
                                                                                placeholder="Descriptions"
                                                                                name="descriptions"
                                                                                onChange={handleChange}
                                                                                defaultValue={dataDetails.descriptions}
                                                                                style={{ height: '100px' }}
                                                                            />
                                                                        </Form.Group>
                                                                    </Row>
                                                                    {error && 
                                                                        <Alert variant="danger">
                                                                            {error}
                                                                        </Alert>
                                                                    }
                                                                    
                                                                    <Button type="submit">Update File</Button>
                                                                </Form>
                                                            </Card.Body>
                                                        </Card>
                                                        
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col lg={12}>
                                                        <Card className="content-list">
                                                            <Card.Header>
                                                                <Row>
                                                                    <Col lg={12}>
                                                                        <Navbar bg="light" expand="lg" className='float-sm-right'>
                                                                            <Navbar.Collapse id="navbarScroll">
                                                                                <Form className="d-flex" onSubmit={searchData}>
                                                                                    <Form.Control
                                                                                        type="search"
                                                                                        placeholder="Search"
                                                                                        className="me-2"
                                                                                        aria-label="Search"
                                                                                        value={query}
                                                                                        onChange={(e) => setQuery(e.target.value)}
                                                                                    />
                                                                                    <Button type="submit" variant="outline-primary">Search</Button>
                                                                                </Form>
                                                                            </Navbar.Collapse>
                                                                        </Navbar>
                                                                    </Col>
                                                                </Row>
                                                            </Card.Header>
                                                            <Card.Body>
                                                                <Table striped hover responsive>
                                                                    <thead>
                                                                        <tr>
                                                                            <th style={{ width: '5%'}} className="text-center">No</th>
                                                                            <th style={{ width: '35%'}} className="text-left">Nama Pasien</th>
                                                                            <th style={{ width: '15%'}} className="text-left">Place Of Birth</th>
                                                                            <th style={{ width: '11%'}} className="text-left">DOB</th>
                                                                            <th style={{ width: '10%'}} className="text-left">Umur</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            dataList.map((item, i) => (
                                                                                <tr key={i}>
                                                                                    <td className="text-center">
                                                                                        {page === 1 ?
                                                                                            i+1 : ( limit * (page-1) ) + (i+1)
                                                                                        }
                                                                                    </td>
                                                                                    <td className="text-left">{item.first_name} {item.middle_name} {item.last_name}</td>
                                                                                    <td className="text-left">{item.place_of_birth}</td>
                                                                                    <td className="text-left">{moment(item.date_of_birth).format('DD-MM-YYYY')}</td>
                                                                                    <td className="text-left">{ getAge(item.date_of_birth) } Tahun</td>
                                                                                </tr>
                                                                            ))
                                                                        }
                                                                    </tbody>
                                                                </Table>
                                                                
                                                            </Card.Body>
                                                            <Card.Footer>
                                                                <Row>
                                                                    <Col lg={3}>
                                                                        <p>Total Data: {rows} Page: {rows ? page : 0} of {pages}</p>
                                                                    </Col>
                                                                    <Col lg={9}>
                                                                        <nav
                                                                            className="pagination float-sm-right"
                                                                            key={rows}
                                                                            role="navigation"
                                                                            aria-label="pagination"
                                                                        >
                                                                            <ReactPaginate
                                                                                previousLabel={"Prev"}
                                                                                nextLabel={"Next"}
                                                                                pageCount={pages}
                                                                                onPageChange={changePage}
                                                                                containerClassName={"pagination-list pagination"}
                                                                                pageLinkClassName={"pagination-link page-link"}
                                                                                previousLinkClassName={"pagination-previous page-link"}
                                                                                nextLinkClassName={"pagination-next page-link"}
                                                                                activeLinkClassName={"pagination-link is-current"}
                                                                                disabledLinkClassName={"pagination-link is-disabled"}
                                                                                activeClassName={"active"}
                                                                                pageClassName={"page-item"}
                                                                            />
                                                                        </nav>
                                                                    </Col>
                                                                </Row>
                                                            </Card.Footer>
                                                        </Card>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col md="12">
                                                        <Card className="content-list">
                                                            <Card.Header>
                                                                <h5>Data Pasien</h5>
                                                            </Card.Header>
                                                            <Card.Body>
                                                                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                                                    <Row className="mb-3">
                                                                        <Form.Group as={Col} md="6" controlId="validationCustom01">
                                                                            <Form.Label>First Name</Form.Label>
                                                                            <Form.Control
                                                                                required
                                                                                type="text"
                                                                                placeholder="First Name"
                                                                                name="first_name"
                                                                                onChange={handleChange}
                                                                            />
                                                                        </Form.Group>
                                                                        <Form.Group as={Col} md="6" controlId="validationCustom02">
                                                                            <Form.Label>Middle Name</Form.Label>
                                                                            <Form.Control
                                                                                type="text"
                                                                                placeholder="Middle Name"
                                                                                name="middle_name"
                                                                                onChange={handleChange}
                                                                            />
                                                                        </Form.Group>
                                                                    </Row>
                                                                    <Row className="mb-3">
                                                                    </Row>
                                                                    <Row className="mb-3">
                                                                        <Form.Group as={Col} md="6" controlId="validationCustom03">
                                                                            <Form.Label>Last Name</Form.Label>
                                                                            <Form.Control
                                                                                // required
                                                                                type="text"
                                                                                placeholder="Last Name"
                                                                                name="last_name"
                                                                                onChange={handleChange}
                                                                            />
                                                                        </Form.Group>
                                                                        <Form.Group as={Col} md="6" controlId="validationCustom05">
                                                                            <Form.Label>Gender</Form.Label>
                                                                            <Form.Control
                                                                                required
                                                                                as="select"
                                                                                name="gender"
                                                                                onChange={handleChange}
                                                                            >
                                                                                <option value="">Select Gender</option>
                                                                                <option value="Male">Male</option>
                                                                                <option value="Female">Female</option>
                                                                            </Form.Control>
                                                                        </Form.Group>
                                                                    </Row>
                                                                    <Row className="mb-3">
                                                                        <Form.Group as={Col} md="6" controlId="validationCustom07">
                                                                            <Form.Label>Phone No</Form.Label>

                                                                            <Form.Control
                                                                                type="number"
                                                                                placeholder="Contoh : 021xxxxxx"
                                                                                name="phone_number"
                                                                                onChange={handleChange}
                                                                            />
                                                                            {/* <Form.Control.Feedback>Validate!</Form.Control.Feedback> */}
                                                                        </Form.Group>
                                                                        <Form.Group as={Col} md="6" controlId="validationCustom06">
                                                                            <Form.Label>Mobilephone</Form.Label>
                                                                            <InputGroup hasValidation>
                                                                                <InputGroup.Text id="inputGroupPrepend">+62</InputGroup.Text>
                                                                                <Form.Control
                                                                                    type="number"
                                                                                    placeholder="Contoh : 812xxxxxx"
                                                                                    name="mobile_phone"
                                                                                    onChange={handleChange}
                                                                                />
                                                                            </InputGroup>
                                                                        </Form.Group>
                                                                    </Row>
                                                                    <Row className="mb-3">
                                                                        <Form.Group as={Col} md="6" controlId="validationEmail">
                                                                            <Form.Label>Email</Form.Label>
                                                                            <Form.Control
                                                                                type="text"
                                                                                placeholder="Email"
                                                                                name="email"
                                                                                onChange={handleChange}
                                                                            />
                                                                        </Form.Group>
                                                                        <Form.Group as={Col} md="6" controlId="validationCustom09">
                                                                            <Form.Label>Place of Birth</Form.Label>
                                                                            <Form.Control
                                                                                type="text"
                                                                                placeholder="Place of Birth"
                                                                                name="place_of_birth"
                                                                                onChange={handleChange}
                                                                            />
                                                                        </Form.Group>
                                                                    </Row>
                                                                    <Row className="mb-3">
                                                                        <Form.Group as={Col} md="6">
                                                                            <Form.Label>Date of Birth</Form.Label>
                                                                            <InputMask
                                                                                name="date_of_birth"
                                                                                mask="99-99-9999"
                                                                                className="form-control"
                                                                                placeholder="DD-MM-YYYY"
                                                                                onChange={handleChange}>
                                                                            </InputMask>
                                                                        </Form.Group>
                                                                        <Form.Group as={Col} md="6" controlId="validationCustom09">
                                                                            <Form.Label>Umur</Form.Label>
                                                                            <Form.Control
                                                                                type="text"
                                                                                placeholder="Umur"
                                                                                name="umur"
                                                                                onChange={handleChange}
                                                                            />
                                                                        </Form.Group>
                                                                    </Row>
                                                                    {error && 
                                                                        <Alert variant="danger">
                                                                            {error}
                                                                        </Alert>
                                                                    }
                                                                    
                                                                    <Button type="submit">Add Pasien</Button>
                                                                </Form>
                                                            </Card.Body>
                                                        </Card>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default Editfile